import { render, staticRenderFns } from "./TaskInfo.vue?vue&type=template&id=3fa4129a&"
import script from "./TaskInfo.vue?vue&type=script&lang=ts&"
export * from "./TaskInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports